/**
 * DESERTLAND.Content.Ideas
 */
import { Utils } from '../cals.utils';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
import Swiper from 'swiper';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.template';
import 'kendo-ui-core/js/kendo.mobile.scrollview';
import 'kendo-ui-core/js/kendo.mobile.listview';
import 'kendo-ui-core/js/kendo.mobile.scroller';

declare var log, info, warn, groupCollapsed, groupEnd;

export class IdeasContent {
  public page = ROUTES.IDEAS;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-ideas';
  public contentSel = '#ideas_content_container';
  public scrollviewSel = "#scrollview";
  public showSlideNum = 0;
  public waiting = false;
  public dataReady = false;
  public plantsReady = false;

  public ideaSwiper: any;

  public init(suffix) {
    groupCollapsed("Ideas.init");
    this.waiting = true;

    if (suffix) {
      info("Ideas.init", suffix);
      let slideNum = Utils.tryParseInt(suffix, 0);
      if (slideNum > 0) {
        this.showSlideNum = slideNum;
      }
    }

    if ($(this.container).length) {
      log("ready for " + this.page);
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        // var me = DESERTLAND.Content.Ideas;
        log(this.page + " dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }

    if (App.data.ideas && App.data.ideas.length > 0) {
      info("idea data ready", App.data.ideas);
      this.dataReady = true;
    } else {
      info("idea data not ready yet", App.data.ideas);
      this.dataReady = false;
      // App.radio.subscribe('dataIdeasReady', this.onDataReady);
      App.service.load.ideas((data) => {
        //log("ideas loaded, listening to radio... %o", data);
        this.onDataReady(data);
        // DESERTLAND.radio('dataIdeasReady').broadcast(data).unsubscribe(DESERTLAND.Content.Ideas.onDataReady);
      });
    }

    if (App.data.plants && App.data.plants.length > 0) {
      info("plant data ready", App.data.plants);
      this.plantsReady = true;
    } else {
      info("plant data not ready yet", App.data.plants);
      this.plantsReady = false;
      // App.radio('dataPlantsReady').subscribe([DESERTLAND.Content.Ideas.onPlantsDataReady, DESERTLAND.Content.Ideas]);
      App.plants.fetchDataThen((data) => {
        this.onPlantsDataReady(data);
        // DESERTLAND.radio('dataPlantsReady').broadcast(data).unsubscribe(DESERTLAND.Content.Hothis.onPlantsDataReady);
      });
    }
    groupEnd("Ideas.init");
  }

  public loadTpl(callback) {
    log(this.page + " > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl, this.tplFadedIn);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      log("%s > renderTpl %o", this.page, resp);
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
  
        if (this.dataReady && this.plantsReady) {
          this.renderGallery();
        }
  
        Utils.smoothScrollTo('top');
  
  
      } else {
        info("no sel?");
      }
    });
  }

  public tplFadedIn(data) {
    info("tplFadedIn %O", data);
    // var me = App.Content.Ideas;
    if (this.waiting) {
      this.renderGallery();
    }
  }

  public onPlantsDataReady(data) {
    //var me = DESERTLAND.Content.Home;//this should be ok duth radio context?
    this.plantsReady = true;
    this.renderGallery();//dataSource.data());
  }

  public onDataReady(data) {
    info("onDataReady %O", data);
    //var me = DESERTLAND.Content.Home;//this should be ok duth radio context?
    this.dataReady = true;
    //data = this.formatData(data);
    this.renderGallery(this.formatData(data));
  }

  public formatData(data) {
    //image: DESERTLAND.config.img_url.ideas + image
    //description: htmlencode
    //title: htmlencode
    // reference: split by | remove \n trim
    let ret = [];
    if (!data) { data = []; }
    for (let i = 0; i < data.length; i++) {
      let m: any = {};//data[i];
      //info(m);
      m.title = this.prep(data[i].title);
      m.description = this.prep(data[i].description);
      m.image = data[i].image;//DESERTLAND.config.img_url.ideas + data[i].image;
      //reference: split by | remove \n trim
      m.nids = data[i].reference.replace(/[^0-9|]+/g, '').split("|");

      //log('formatted: %O (( %O', m, data[i]);
      ret.push(m);
    }
    App.data.ideas = ret;
    return ret;
  }

  public prep(s) {
    //return Utils.escapeHtml(s).replace(/#/g, '\\\\\\\\#').replace(/(?:\r\n|\r|\n)/g, '<br>');
    // return Utils.escapeHtml(s).replace(/#/g, '&#35;').replace(/(?:\r\n|\r|\n)/g, '<br>');
    return Utils.escapeHtml(s).replace(/#/g, '').replace(/(?:\r\n|\r|\n)/g, '<br>');
    //return Utils.escapeHtml(s).replace(/(?:\r\n|\r|\n)/g, '<br>');

  }

  public renderGallery = (data = {}) => {
    groupCollapsed("Ideas.Render");
    info("renderGallery %O", data);
    let $sel = $(this.contentSel);

    if (!this.dataReady || !$sel.length || !App.data.ideas || App.data.ideas.length < 1 || !App.data.plants || App.data.plants.length < 1) {
      this.waiting = true;
      let s = "gallery not ready yet, waiting for: ";

      if (!this.dataReady) { info(s + "!dataReady"); }
      if (!$sel.length) { info(s + "!sel.len"); }
      if (!App.data.ideas) { info(s + "!data.ideas", App.data.ideas); }
      if (!App.data.plants) { info(s + "!data.plants", App.data.plants); }
      groupEnd("Ideas.Render");
    } else {
      this.waiting = false;
      info("ok, gallery data ready", App.data.ideas);

      // var dataSource = new kendo.data.DataSource({
      //     data: DESERTLAND.data.ideas
      // });
      // info(dataSource);

      /*
      <div class="swiper-container">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
              <!-- Slides -->
              <div class="swiper-slide">Slide 1</div>
              <div class="swiper-slide">Slide 2</div>
              <div class="swiper-slide">Slide 3</div>
              <div class="swiper-slide">Slide 4</div>
              <div class="swiper-slide">Slide 5</div>
              <div class="swiper-slide">Slide 6</div>
              
          </div>
          <!-- If we need pagination -->
          <div class="swiper-pagination"></div>
          
          <!-- If we need navigation buttons -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          
          <!-- If we need scrollbar -->
          <div class="swiper-scrollbar"></div>
      </div>
      */


      let itemTpl = '<div class="gallery-item swiper-slide" data-hash="idea-#= order #">'
        //+ '<div class="image" style="background-image: url(#= DESERTLAND.config.img_url.ideas ##= image #);"></div>'
        + '<div class="image"><img class="gallery-image" src="#= data.Config.img_url.ideas ##: image #" alt="#: title #"></div>'
        + '<div class="title">#= title #</div>'
        + '<p class="desc">#= description #</p>'
        + '<div class="gallery-item-scroller">'
        + '<ol id="gallery-listview-#= order #" class="gallery-item-listview">'
        + '# for (var i = 0; i < nids.length; i++) { #'
        + '<li>#= data.ideaContent.renderGalleryItem(nids[i], order) #</li>'
        + '# } #'
        + '</ol></div>'
        + '</div>';



      //$sel.hide().empty();
      $sel.empty();

      let $wrap = $("<div></div>").attr({ id: this.scrollviewSel.replace('#', '') }).addClass("idea-gallery swiper-container").appendTo($sel), //attr({'data-role':'view'}).
        $scroll = $("<div></div>").addClass('swiper-wrapper').appendTo($wrap);

      $wrap.prepend('<div class="swiper-pagination"></div>').append('<div class="swiper-button-prev"></div>').append('<div class="swiper-button-next"></div>');

      // create items
      //$scroll.append('<div class="swiper-slide">Slide 1</div><div class="swiper-slide">Slide 2</div><div class="swiper-slide">Slide 3</div><div class="swiper-slide">Slide 4</div><div class="swiper-slide">Slide 5</div><div class="swiper-slide">Slide 6</div>');

      let _itemTemplate = kendo.template(itemTpl),
        result;

      for (let i = 0; i < App.data.ideas.length; i++) {
        App.data.ideas[i].order = i + 1;
        //log(DESERTLAND.data.ideas[i]);
        let templateData = App.data.ideas[i];
        templateData.Config = App.config;
        templateData.ideaContent = App.content.Ideas;

        result = _itemTemplate(App.data.ideas[i]);
        $scroll.append(result);

      }

      // //$(".gallery-item-scroller").kendoMobileScroller();

      // $("#plant-selector-listview").kendoMobileListView({ 
      //     dataSource: DESERTLAND.Plants.datasource,
      //     template : $("#" + DESERTLAND.Plants.tplSelSub).html(), 
      //     dataBound(e) {
      //         log("plant-selector-listview onDataBound",e);
      //         $(DESERTLAND.Plants.subContainer + " > li").addClass("col-sm-4");
      //     }
      // }); 


      //http://idangero.us/swiper
      this.ideaSwiper = new Swiper(this.scrollviewSel, {
        // Optional parameters
        direction: 'horizontal',
        loop: false,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        //enable hash navigation
        //hashnav: true // messes with hash routing...

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });
      // DESERTLAND.ideaSwiper.update();

      //  add callback
      this.ideaSwiper.on('slideChangeStart', function (swiper) {
        // per API: Note, that in loop mode active index value will be always shifted on a number of looped/duplicated slides

        //info(typeof swiper.activeIndex);
        if (swiper && typeof swiper.activeIndex === "number") {
          //info('swiper slideChangeStart > activeIndex:', swiper.activeIndex, swiper);
          let newNum = swiper.activeIndex + 1;
          App.router.navigate("/ideas/" + newNum, true);//silent
          App.shareUrl = 'ideas/?share=' + 'ideas' + "&loc=" + (swiper.activeIndex + 1);
          App.controller.updateShareVars("Desert Landscaping :: Ideas Gallery Item " + newNum, { loc: newNum });
        }
      });

      // if there's a this.showSlideNum (from init) - show it
      if (this.showSlideNum > 0) {
        this.ideaSwiper.slideTo(this.showSlideNum - 1);//, speed, runCallbacks);	
      }
    }

    groupEnd("Ideas.Render");
  }

  public renderGalleryItem(nid, index) {
    let urlSpec = (typeof index === "number" && index > 0) ? '/ideas/' + index : "",
      html = nid,//"",
      listTpl = '<div class="plant-list-item">'
        + '<a href="/\\#/plant/#: nid #/#= data.Utils.changeSpacesToDashes(common_name) #' + urlSpec + '" class="plant-list-item-link clearfix">'
        + '<img src="#= data.Config.img_url.plant ##= image #" class="img-responsive plant-thumb pull-left" alt="#= common_name #" />'
        + '<div class="plant-list-common-name">#= common_name #</div>'
        + '<div class="plant-list-botanical-name"><em>#= botanical_name #</em></div>'
        + '<div class="plant-list-type">Type: #: plant_group #</div>'
        + '</a>'
        + '</div>';


    let thisPlant = App.data.plants.find(function (item) {
      return item.nid === nid;

    });
    //info(nid, thisPlant); 

    if (thisPlant) {
      thisPlant.Utils = Utils;
      thisPlant.Config = App.config;
      let _itemTemplate = kendo.template(listTpl);
      html = _itemTemplate(thisPlant);
    }



    return html;

  }


}
